import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Form } from "antd";
import { useState } from "react";
import { FacingFinGroup } from "tm-shared/types";

import BaseButton from "@/shared/ui/BaseButton";
import { ContractFormValues } from "@/types/form";

import { AddFinGroupModal } from "../AddFinGroupModal";
import { ContractFacingsRow } from "./ContractFacingsRow";
import { StyledErrorsWrapper } from "./Styled";

export const Facings = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const form = Form.useFormInstance<ContractFormValues>();

    const menuItems = [
        {
            key: "1",
            label: (
                <Flex gap="5px" align="center">
                    <DeleteOutlined /> Видалити
                </Flex>
            ),
        },
    ];

    return (
        <Flex vertical gap={20} style={{ marginBottom: 24 }}>
            <BaseButton type="primary" onClick={() => setIsModalOpen(true)}>
                Обрати фінансові групи
            </BaseButton>

            <Flex vertical gap={12}>
                <Form.List name="facings">
                    {(fields, { remove, add }, { errors }) => {
                        const selectedFacings: FacingFinGroup[] =
                            form.getFieldValue("facings") || [];
                        return (
                            <>
                                {fields.map((field) => {
                                    const finGroup = form.getFieldValue([
                                        "facings",
                                        field.name,
                                        "finGroup",
                                    ]);

                                    return (
                                        <ContractFacingsRow
                                            key={field.key}
                                            finGroup={finGroup}
                                            field={field}
                                            menuItems={menuItems}
                                            remove={remove}
                                        />
                                    );
                                })}

                                <StyledErrorsWrapper>
                                    <Form.ErrorList errors={errors} />
                                </StyledErrorsWrapper>

                                <AddFinGroupModal
                                    open={isModalOpen}
                                    onClose={() => setIsModalOpen(false)}
                                    selectedFinGroups={selectedFacings}
                                    onAdd={add}
                                    onRemove={(finGroup) => {
                                        const index = selectedFacings.findIndex(
                                            (p) => p.finGroup === finGroup,
                                        );
                                        if (index !== -1) remove(index);
                                    }}
                                />
                            </>
                        );
                    }}
                </Form.List>
            </Flex>
        </Flex>
    );
};
